module.exports = __webpack_public_path__ + "static/media/stop-5.432b20c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/stop-markers/stop-5.svg
// module id = 1350
// module chunks = 0